<template>
  <span>
    <AppSelectCheckboxes
      v-if="!ignoreCheckboxesView && showCheckboxesView()"
      v-model="givenValue"
      :items="items"
      v-bind="$attrs"
    />
    <v-select
      v-else
      v-model="givenValue"
      v-show-fade="{ isFilter: isFilter }"
      v-bind="$attrs"
      :menu-props="menuProperties"
      :items="items"
      autocomplete="off"
      :clearable="clearable"
      :hide-details="$attrs['hide-details'] === false ? false : true"
      outlined
      :data-test="$attrs['data-test']"
      :class="[selectMixinClass]"
      @change="inputVisibility($event, 'change')"
      @focus="focused"
      @blur="inputVisibility"
      v-on="$listeners"
    >
      <template #selection="{item}">
        {{
          item.code ||
            item.name ||
            item.text ||
            item.rate ||
            item[$attrs["item-text"]] ||
            item
        }};
      </template>
    </v-select>
  </span>
</template>
<script>
import AppSelectCheckboxes from "./AppSelectCheckboxes.vue";
import selectsMixin from "./selects_mixin";
export default {
  name: "AppGenericSelect",
  components: { AppSelectCheckboxes },
  mixins: [selectsMixin],
  data() {
    return {
      menuProperties: {
        minWidth: 280
      }
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  created() {
    this.menuProperties.nudgeBottom = this.nudgeBottom;
  }
};
</script>
